<template>
    <v-container class="pa-0 ma-0" >

        <v-card >
            <v-card-text>

                    <v-row>
                        <v-col
                        cols="12"
                        md="12"
                        >
                           <h1>Change Password</h1>
                        </v-col>
                    </v-row>

                <v-form v-model="valid" id="changepassword"  >
                    <v-container>
                        <v-row>
                            <v-col cols="12" md="12" class="text-center">
                            <v-text-field
                                v-model="password"
                                type="password"
                                name="password"
                                label="New Password"
                                v-validate="'required|min:6'"
                                :error-messages="errors.collect('password')"
                                data-vv-name="password"
                                ref="password"
                            ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="12" class="text-center">
                            <v-text-field
                                v-model="password_confirmation"
                                type="password"
                                name="password_confirmation"
                                label="Confirm Password"
                                v-validate="'required|confirmed:password'"
                                :error-messages="errors.collect('password_confirmation')"
                                data-vv-name="password_confirmation"
                            ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row>
                            <v-col cols="4">
                                <v-btn color="primary" @click="$router.push({name:'dashboardbusiness'})">Cancel</v-btn>

                            </v-col>
                            <v-col cols="8">
                                <v-btn color="primary" @click="submitchangepassword">Change Password</v-btn>

                            </v-col>
                        </v-row>

                    </v-container>
                </v-form>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import Vue from "vue";
import moment from "moment";
export default {
  props: {
    source: String
  },
  data: () => ({
    passwordreset:false,
    valid: true,
    password:'',
    password_confirmation:'',
    storeBusiness: [],

  }),
  computed: {
    isAuthorised() {
      return this.$store.getters.isLoggedin;
    },

  },
  created() {
    //    if (this.$route.params.key) {
    //   this.key = this.$route.params.key;
    //    }

    // this.getBusiness();
    if(localStorage.getItem('isLoggedin')=='true')
    {
        this.isloggedin=true;
    }else{
        this.isloggedin=false;
    }

    this.storeBusiness = JSON.parse(localStorage.getItem("business"));

  },
  methods: {
    submitchangepassword()
    {

      if (this.$validator.validateAll()) {
          let fd = new FormData(document.getElementById('changepassword'));
          this.$http.post('https://api.juzzap.com/api/changepas',fd)
        .then(res=>{

        //this.logout();
        this.passwordreset=true;
        this.password='';
        this.password_confirmation='';
        this.$router.push({name:'dashboardbusiness'})
        })
        .catch(err=>{
          console.log(err.response);
        });
      }
    },
  }
}
</script>
